import React from 'react'
import concatAnswerStrings from '../../../helpers/content/concatAnswerStrings';
import createMarkup from '../../../helpers/createMarkup';
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText';

export default function ItemRows({items, activeItemId, handleClickItem, filter}) {
  function filterRules(item) {
    const answers = concatAnswerStrings(item.answers)
    return item.code.toLowerCase().indexOf(filter) > -1 ||
           item.question.toLowerCase().indexOf(filter) > -1 ||
           answers.toLowerCase().indexOf(filter) > -1
  }
  const filteredItems = filter ? items.filter(filterRules) : items
  const sortedItems = sortByPropText(filteredItems, 'code')
  return (
    <tbody>
      {sortedItems.map((item, n) =>{
        const answers = concatAnswerStrings(item.answers)
        const preview = createMarkup(item.question || answers)
        return <tr
          key={`itemRow${n}`}
          className={item.itemId === activeItemId ? 'bg-info' : 'm2clickable'}
          onClick={() => handleClickItem(item)}
        >
          <td>{item.code}</td>
          <td dangerouslySetInnerHTML={preview}></td>
        </tr>
      })}
    </tbody>
  )    
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/ItemRows.js